import { InsightsFiltersOptionsQuery } from 'generated/resources/graphql'
import { orderBy } from 'lodash'

import { useUnsafeMemo } from 'modules/core/hooks/useMemo'

export const useLegalEntityOptions = (filtersOptionsData: InsightsFiltersOptionsQuery) => {
  const options = useUnsafeMemo(
    () =>
      orderBy(
        filtersOptionsData.companies.legalEntitiesConnection.nodes,
        ['main', 'legalName'],
        ['desc', 'asc']
      ).map((legalEntity) => ({
        label: legalEntity.legalName ?? '',
        value: legalEntity.id,
      })),
    [filtersOptionsData]
  )

  return options
}
